export default __webpack_public_path__ + "static/media/88.e01ad84b.png";